import { render, staticRenderFns } from "./PrivateLimitedRegistration.vue?vue&type=template&id=3c86d35e&scoped=true"
import script from "./PrivateLimitedRegistration.vue?vue&type=script&lang=js"
export * from "./PrivateLimitedRegistration.vue?vue&type=script&lang=js"
import style0 from "./PrivateLimitedRegistration.vue?vue&type=style&index=0&id=3c86d35e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c86d35e",
  null
  
)

export default component.exports